import { FC } from 'react'
import { Button, Typography } from '@material-tailwind/react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { colors } from '@material-tailwind/react/types/generic'

interface RedeemCodeMessageProps {
  redeemCodeError: string | null
  setRedeemCodeError: (error: string | null) => void
  setRedeemCode: (code: string | null) => void
  urlParamCode?: string | null
  textColor?: string
}

const RedeemCodeMessage: FC<RedeemCodeMessageProps> = ({
  redeemCodeError,
  setRedeemCodeError,
  setRedeemCode,
  urlParamCode,
  textColor,
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const handleClearCode = () => {
    setRedeemCode('')
    setRedeemCodeError(null)
    if (urlParamCode) {
      // remove from URL
      navigate(pathname, { replace: true })
    }
  }

  return (
    <>
      {redeemCodeError && (
        <>
          <Typography className="font-italic font-bold mt-1" variant="small" color="red">
            {redeemCodeError}
          </Typography>
          <Button size="sm" onClick={handleClearCode}>
            {t('common.clearCode')}
          </Button>
        </>
      )}
      {!redeemCodeError && (
        <Typography className="font-italic mt-1" variant="small" color={textColor as colors}>
          {t('redeemCode.thankYouMessage')}{' '}
          <Link to="/faq#code-faq" className="underline" target="_blank" rel="noopener noreferrer">
            {t('redeemCode.needHelp')}
          </Link>
        </Typography>
      )}
    </>
  )
}

export default RedeemCodeMessage
